import { useState, useEffect } from "react";

import axios from "axios";
import Loader from "../../UI/Loader/Loader";
import { useTheme } from "@mui/material/styles";
import { useFilters } from "../../../Context/FiltersContext";
import { MenuProps, getStyles, Headers, useStyles } from "../Utils";
import { Select, MenuItem, FormControl, FormHelperText } from "@mui/material";
import { INVOKE_URL } from "../../../constants/api";

const FixVersions = () => {
  const theme = useTheme();
  const { projectKey, fixVersion, setFixVersion } = useFilters();
  const [listFixVersions, setListFixVersions] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  const projectKeySS = JSON.parse(sessionStorage.getItem("projectKey"));
  const sessionStorageItem = JSON.parse(sessionStorage.getItem("fixVersion"));
  const URL = `${INVOKE_URL}/fixversions?projectKey=${projectKeySS}`;

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    fetchFixVersions(signal);

    return () => {
      controller.abort();
    };
  }, [projectKey]);

  const fetchFixVersions = async (signal) => {
    try {
      // const response = await axios.get(`/multiSelect/version/${projectKeySS}`, {signal: signal}); // Dev only test
      if (projectKeySS?.length) {
        const response = await axios.get(URL, { Headers, signal });
        setListFixVersions(response.data);
        setLoader(false);
      }
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 450 }}>
      <Select
        label="fixVersions"
        id="fixVersions"
        multiple={true}
        value={sessionStorageItem ?? []}
        onChange={(e) => {
          setFixVersion(e.target.value);
          localStorage.setItem("fixVersion", e.target.value); // Storing value so it can be displayed in the Preview page.
          sessionStorage.setItem("fixVersion", JSON.stringify(e.target.value));
          setIsOpen(false);
        }}
        renderValue={(selected) => selected.join(", ")}
        MenuProps={MenuProps}
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
      >
        {!loader ? (
          Array.isArray(listFixVersions) && listFixVersions.length > 0 ? (
            // Show the latest fixed version date at the top.
            listFixVersions
              .slice(0)
              .reverse()
              .map((data, id) => (
                <MenuItem key={id} value={data} style={getStyles(data, fixVersion, theme)}>
                  {data}
                </MenuItem>
              ))
          ) : (
            <MenuItem disabled={true}>No versions available..</MenuItem>
          )
        ) : (
          <Loader />
        )}
      </Select>
      <FormHelperText style={useStyles.formHelperText}>Choose one or multiple fixed versions.</FormHelperText>
    </FormControl>
  );
};

export default FixVersions;
